<template>
  <div :class="elem.classes">
    <div class="row -mx-gd-half">
      <div class="col px-gd-half">
        <b-input-group>
          <FormInputNumber2 
            class="text-center_" 
            :max="80" 
            :unit="'px'" 
            :value="root.value.top" 
            @input="(value) => { onInput('top', value) }" 
            @change="(value) => { onChange('top', value) }" 
          />
          <FormInputNumber2 
            class="text-center_" 
            :max="80" 
            :unit="'px'" 
            :value="root.value.right" 
            @input="(value) => { onInput('right', value) }" 
            @change="(value) => { onChange('right', value) }" 
          />
          <FormInputNumber2 
            class="text-center_" 
            :max="80" 
            :unit="'px'" 
            :value="root.value.bottom" 
            @input="(value) => { onInput('bottom', value) }" 
            @change="(value) => { onChange('bottom', value) }" 
          />
          <FormInputNumber2 
            class="text-center_" 
            :max="80" 
            :unit="'px'" 
            :value="root.value.left" 
            @input="(value) => { onInput('left', value) }" 
            @change="(value) => { onChange('left', value) }" 
          />
        </b-input-group>
        <!-- <b-input-group>
          <InputUnit 
            :unit="'pixel'" 
            :min="0" 
            :max="80" 
            :value="root.value.top" 
            @input="(value) => { onInput('top', value) }"
            @change="(value) => { onChange('top', value) }"
          />
          <InputUnit 
            :unit="'pixel'" 
            :min="0" 
            :max="80" 
            :value="root.value.right" 
            @input="(value) => { onInput('right', value) }"
            @change="(value) => { onChange('right', value) }"
          />
          <InputUnit 
            :unit="'pixel'" 
            :min="0" 
            :max="80" 
            :value="root.value.bottom" 
            @input="(value) => { onInput('bottom', value) }"
            @change="(value) => { onChange('bottom', value) }"
          />
          <InputUnit 
            :unit="'pixel'" 
            :min="0" 
            :max="80" 
            :value="root.value.left" 
            @input="(value) => { onInput('left', value) }"
            @change="(value) => { onChange('left', value) }"
          />
        </b-input-group> -->
        <div class="row -mx-0">
          <div class="col px-0 text-center"><span class="fs-sa-12 text-hint">{{ $t('engine.manageGridCell.sidebar.padding.lblTop', languageEngine) }}</span></div>
          <div class="col px-0 text-center"><span class="fs-sa-12 text-hint">{{ $t('engine.manageGridCell.sidebar.padding.lblRight', languageEngine) }}</span></div>
          <div class="col px-0 text-center"><span class="fs-sa-12 text-hint">{{ $t('engine.manageGridCell.sidebar.padding.lblBottom', languageEngine) }}</span></div>
          <div class="col px-0 text-center"><span class="fs-sa-12 text-hint">{{ $t('engine.manageGridCell.sidebar.padding.lblLeft', languageEngine) }}</span></div>
        </div>
        <!-- <pre style='font-size: 10px;'>root.value = {{ root.value }}</pre> -->
      </div>
      <div class="col-auto text-center px-gd-half">
        <b-button
          variant="transparent"
          class="px-gd-1"
          :class="{
            active: Boolean(root.value.sync),
          }"
          @click="onChangeLinked(!root.value.sync)"
        >
          <IconLink class="rotate-135 -mt-3" style="height: 14px;" v-show="root.value.sync"/>
          <IconUnlink class="rotate-135 -mt-3" style="height: 14px;" v-show="!root.value.sync"/>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IconLink from "@components_system/Shared/Images/Icon/IconLink";
import IconUnlink from "@components_system/Shared/Images/Icon/IconUnlink";
// import InputUnit from "@components_system/Shared/Tools/InputUnit/InputUnit";
import FormInputNumber2 from "@components_system/Shared/Tools/FormInputNumber2/FormInputNumber2";

export default {
  components: {
    IconLink,
    IconUnlink,
    // InputUnit,
    FormInputNumber2,
  },
  props: {
    sync: {
      type: Boolean,
      default: undefined,
    },
    top: {
      type: [String, Number],
      default: undefined,
    },
    left: {
      type: [String, Number],
      default: undefined,
    },
    right: {
      type: [String, Number],
      default: undefined,
    },
    bottom: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
		return {
			root: {
        value: {
          sync: true,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
      }
		}
	},
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    // Elements
    elem() {
      return {
        classes: {
          "mwe-input-padding": true,
        },
      }
    },
  },
  methods: {
    normalizeValue(value) {
      let _value = value;
      if (value.sync === true && (value.left != value.top || value.right != value.top || value.bottom != value.top)) {
        _value.sync = false;
      }
      return _value;
    },

    onInput(side, val) {
      let sync = this.root.value.sync;
      let value = sync 
      ? this.normalizeValue({ 
        ...this.root.value, 
        top: val, 
        left: val, 
        right: val, 
        bottom: val, 
      }) 
      : this.normalizeValue({ 
        ...this.root.value, 
        [side]: val, 
      });
    
      this.root.value = value;
      this.$emit(`update:${side}`, value[side]);
      if (sync) {
        if (side != 'top') this.$emit('update:top', value.top);
        if (side != 'left') this.$emit('update:left', value.left);
        if (side != 'right') this.$emit('update:right', value.right);
        if (side != 'bottom') this.$emit('update:bottom', value.bottom);
      }
      this.$emit('input', value);
    },
    onChange(side, val) {
      let sync = this.root.value.sync;
      let value = sync 
      ? this.normalizeValue({ 
        ...this.root.value, 
        top: val, 
        left: val, 
        right: val, 
        bottom: val, 
      }) 
      : this.normalizeValue({ 
        ...this.root.value, 
        [side]: val, 
      });
    
      this.root.value = value;
      this.$emit(`update:${side}`, value[side]);
      if (sync) {
        if (side != 'top') this.$emit('update:top', value.top);
        if (side != 'left') this.$emit('update:left', value.left);
        if (side != 'right') this.$emit('update:right', value.right);
        if (side != 'bottom') this.$emit('update:bottom', value.bottom);
      }
      this.$emit('change', value);
    },
    onChangeLinked(val) {
      let sync = val;
      let main = Math.max(this.root.value.top, this.root.value.left, this.root.value.right, this.root.value.bottom);
      let value = sync 
      ? this.normalizeValue({ 
        ...this.root.value, 
        sync: val,
        top: main, 
        left: main, 
        right: main, 
        bottom: main, 
      }) 
      : this.normalizeValue({ 
        ...this.root.value, 
        sync: val,
      });

      this.root.value = value;
      this.$emit('update:sync', value.sync);
      this.$emit('change', value);
      this.$emit('input', value);
    },
  },
  mounted() {
    this.root.value = this.normalizeValue({
      sync: this.sync,
      top: this.top,
      left: this.left,
      right: this.right,
      bottom: this.bottom,
    });
  },
  watch: {
    sync(newValue) {
      this.root.value = this.normalizeValue({ ...this.root.value, sync: newValue });
    },
    top(newValue) {
      this.root.value = this.normalizeValue({ ...this.root.value, top: newValue });
    },
    left(newValue) {
      this.root.value = this.normalizeValue({ ...this.root.value, left: newValue });
    },
    right(newValue) {
      this.root.value = this.normalizeValue({ ...this.root.value, right: newValue });
    },
    bottom(newValue) {
      this.root.value = this.normalizeValue({ ...this.root.value, bottom: newValue });
    },
  },
}
</script>
